import styled from 'styled-components';

export const ThumbsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 512px) {
    display: none;
  }
`;

export const ThumbsElement = styled.div`
  cursor: pointer;
  position: relative;
  width: 20%;
  height: 100px;
  border: 1px solid ${({ theme }) => theme.colors.color_white};
  box-sizing: border-box;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &::after {
    ${({ idCurrentPhoto, idx }) =>
      idCurrentPhoto !== idx &&
      `
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      opacity: 0.4;
      background-color: black;
      `}
  }

  @media (max-width: 1024px) {
    height: 120px;
  }

  @media (max-width: 900px) {
    height: 100px;
  }

  @media (max-width: 768px) {
    height: 90px;
  }

  @media (max-width: 650px) {
    height: 80px;
  }

  @media (max-width: 600px) {
    height: 70px;
  }
`;
